// Shared offline guard for every financial write path (Expense, Income,
// Material, Labour, Import). Deliberately tiny: no queueing, no local storage
// of financial data, no invented offline auth -- just a clear refusal before
// any Supabase call is attempted.
export const OFFLINE_SAVE_MESSAGE = 'Internet connection required to save financial data.';

export function isOnline() {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}
